<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-维修记录-添加
    -->
    <el-dialog
    title="添加维修记录"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="60%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加维修记录</div>

      <el-form-item label="维修名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入维修记录名称" class="max-w460"></el-input>
      </el-form-item>
    
      <!-- 新增字段：选择用户 -->
      <el-form-item label="用户" :rules="[{required: true,message: '请选择用户'}]">
        <div class="d-s-s d-c">
          <el-button @click="openUser" icon="el-icon-plus">选择用户</el-button>
          <ul class="d-s-s select-user">
            <li v-if="user.user_id" class="mr10 d-c-c d-c p-10-0">
              <img :src="user.avatarUrl || '/static/images/default_avatar.png'" class="radius" width="30" height="30" />
              <p class="lh18 ww100 text-ellipsis">{{user.nickName}}</p>
            </li>
          </ul>
        </div>
      </el-form-item>

      <!-- 新增字段：上门时间 -->
      <el-form-item label="上门时间" prop="service_time">
        <el-date-picker
          v-model="form.service_time"
          type="datetime"
          placeholder="选择上门时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          class="max-w460">
        </el-date-picker>
      </el-form-item>

      <!-- 新增字段：维修状态 -->
      <el-form-item label="维修状态" prop="status">
        <el-select v-model="form.status" placeholder="请选择维修状态" class="max-w460">
          <el-option label="待处理" :value="1"></el-option>
          <el-option label="已派单" :value="2"></el-option>
          <el-option label="维修中" :value="3"></el-option>
          <el-option label="已完成" :value="4"></el-option>
          <el-option label="已取消" :value="5"></el-option>
        </el-select>
      </el-form-item>

      <!-- 维修前图片 -->
      <el-form-item label="维修前图片：" prop="before_images">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.before_images">
            <transition-group>
              <div v-for="(item, index) in form.before_images" :key="item.file_path">
                <div class="item">
                  <img v-img-url="item.file_path" alt="维修前图片"/>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'before')"><i class="el-icon-close"></i></a>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openProductUpload('before')">
            <i class="el-icon-plus"></i>
          </div>
        </div>
        <div class="tip-text">上传维修前的现场照片</div>
      </el-form-item>

      <!-- 维修后图片 -->
      <el-form-item label="维修后图片：" prop="after_images">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.after_images">
            <transition-group>
              <div v-for="(item, index) in form.after_images" :key="item.file_path">
                <div class="item">
                  <img v-img-url="item.file_path" alt="维修后图片"/>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'after')"><i class="el-icon-close"></i></a>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openProductUpload('after')">
            <i class="el-icon-plus"></i>
          </div>
        </div>
        <div class="tip-text">上传维修完成后的照片</div>
      </el-form-item>

      <!-- 维修备注 -->
      <el-form-item label="维修备注" prop="remark">
        <el-input
          type="textarea"
          :rows="3"
          v-model="form.remark"
          placeholder="请输入维修备注信息"
          class="max-w460">
        </el-input>
      </el-form-item>

      <!-- 维修评价 -->
      <el-form-item label="维修评价" prop="evaluation">
        <el-input
          type="textarea"
          :rows="3"
          v-model="form.evaluation"
          placeholder="请输入用户评价"
          class="max-w460">
        </el-input>
      </el-form-item>

      <el-form-item label="排序" prop="sort">
        <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
      </el-form-item>
       
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    
     <!--图片上传组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
     </Upload>
     
     <!-- 选择用户组件 -->
     <UserSelect :is_open="isOpenUser" :multi="false" @close="closeUserFunc"></UserSelect>
  </div>
</el-dialog>
</template>

<script>
import Maintenance_recordApi from '@/api/maintenance_record.js';
import Upload from '@/components/file/Upload';
import UserSelect from '@/components/user/Select.vue'; // 用户选择组件
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';

export default {
  components: {
     Upload,
     UserSelect,
     draggable,
     Uediter
  },
  data() {
    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,  
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 300
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        user_id: 0,
        service_time: '',
        status: 1, // 默认待处理
        before_images: [], // 维修前图片
        after_images: [], // 维修后图片
        remark: '',
        evaluation: '',
        intro: "",
        sort: 50
      },
      // 用户信息
      user: {},
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入维修记录名称', trigger: 'blur' }],
        service_time: [{ required: true, message: '请选择上门时间', trigger: 'change' }],
        status: [{ required: true, message: '请选择维修状态', trigger: 'change' }],
        remark: [{ required: true, message: '请输入维修备注', trigger: 'blur' }]
      },
      dialogVisible: false,
      isProductUpload: false,
      code: "before", // 当前上传的图片类型
      // 选择用户开关
      isOpenUser: false
    };
  },
  created() {
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {
    /*打开选择用户*/
    openUser() {
      this.isOpenUser = true;
    },
    
    /*关闭选择用户*/
    closeUserFunc(e) {
      if (e.type != 'error') {
        this.form.user_id = e.params.user_id;
        this.user = e.params;
      }
      this.isOpenUser = false;
    },

    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, "type": "" });
    },
    
    cancelFunc() {
      this.dialogFormVisible("error");
    },

    onSubmit() {
      let self = this;
      let form = self.form;
       form.user_id = self.user.user_id
  
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Maintenance_recordApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*打开上传图片*/
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code;
    },

    /*上传图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true;
              return false;
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        // 根据当前上传类型添加到对应的图片数组
        if (this.code == 'before') {
          let imgs = this.form.before_images.concat(e);
          this.$set(this.form, "before_images", imgs);
        } else if (this.code == 'after') {
          let imgs = this.form.after_images.concat(e);
          this.$set(this.form, "after_images", imgs);
        }
      }
      
      this.isProductUpload = false;
    },

    /*删除图片*/
    deleteImg(index, type) {
      if (type == 'before') {
        this.form.before_images.splice(index, 1);
      } else if (type == 'after') {
        this.form.after_images.splice(index, 1);
      }
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 300px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.select-user {
  margin-top: 10px;
}

.select-user li {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 5px 10px;
  background-color: #f5f7fa;
}

.max-w460 {
  max-width: 460px;
}

.tip-text {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}

.el-form-item {
  margin-bottom: 15px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/maintenance_record/index/part/add.vue